import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext, useStore } from '~/contexts';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { usePreviewDraft } from '~/hooks/usePreviewDraft';
import { selectors } from '~/store/state-selectors';
import { navigateForRow } from './useRecentAgreementNavigation.utils';
export function useRecentAgreementNavigation() {
    const navigate = useNavigate();
    const overlayContext = useOverlayContext();
    const worksAt = useStore(selectors.user.business);
    const { contactsMap, sampleContact } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const { previewDraft } = usePreviewDraft({
        sampleContact,
        contactsMap
    });
    return useMemo(()=>(row)=>()=>navigateForRow(row, navigate, overlayContext, previewDraft), [
        previewDraft
    ]);
}
